<div class="modal-body">
  <div class="modal-header">
    <div class="user-icon-title-container">
      <span class="lato-18-n-vw message">
      </span>
    </div>
    <div class="close-icon" cygovSvgIcon [svgName]="'x-icon-type2'" (click)="closeModal()">
    </div>
  </div>
  <div class='modal-content-body'>
    <div class="main-container">
      <div class="header-main-area">
        <div class="ese-main-heading lato-18-n-vw"><span class="blue-text">CREATE EMERGING SECURITY
            EVENT (ESE)</span> | BUILD DEFAULT QUESTIONNAIRE</div>
      </div>
      <div class="progress-status">
        <div class="steps-toggle-icons-cont">
          <ng-container *ngFor="let step of steps; let i = index">
            <div [ngClass]="['bulk-risk-step', 'bulk-' + step.num.toLowerCase() + '-step']">
              <div class="round-checkbox">
                <input [id]="'label-icon-step' + i" type="radio" [name]="'icon-step' + i"
                  [checked]="step.active || step.completed" />
                <label [for]="'label-icon-step' + i" class="lato-14-n-vw capitalize label standard">
                </label>

                <div cygovSvgIcon [svgName]="'right-tick'" class="completed-right-tick"
                  [ngStyle]="{ opacity: step.completed ? 1 : 0 }"></div>
              </div>
              <div class="round-checkbox-label">
                <span class="lato-16-n-vw"
                  [ngStyle]="{ color: step.active ? '#29A9EB' : '#fff' }">{{ step.title }}</span>
              </div>
            </div>
          </ng-container>
        </div>

      </div>
      <div class="steps-toggle-body">
        <div class="ese-template-step-content abs-centre" *ngIf="steps[0].active">
          <div class='download-csv-box cursor-pointer' (click)="onDownload()">
            <div class='download-btn-icon abs-centre'>
              <div cygovSvgIcon [svgName]="'download-report-icon'" class='download-icon-svg'>
              </div>
            </div>
            <div class='download-btn-text lato-25-n-vw'>
              Download XLSX Template
            </div>
          </div>
        </div>
        <div class="ese-template-step-content ese-second-step-content abs-centre"
          *ngIf="steps[1].active">
          <ng-container>
            <cygov-upload-file [uploadPath]='""' [uploadType]="'.xlsx'" [restrictFileDrop]="'.xlsx'"
              [displayMessage]="''" [loaderType]="uploadStateEnum.STYLE1"
              [requiredInfo]="requiredInfo" [isFakeUpload]="true" [invalidFile]="invalidFileData"
              [multiSelect]="false" [isVendorBulkUpload]="true">
            </cygov-upload-file>


          </ng-container>
        </div>
        <div class="ese-third-step-content" *ngIf="steps[2].active">
          <cygov-emerging-security-event-action-buttons [isCreateFromTemplate]="true"
            [isEditMode]="isEditMode" (upload)="onUpload($event)" (download)="onDownload()"
            (save)="onSave()" (delete)="onDelete()" (enableEdit)="enableEdit($event)"
            [questions]="questions" [disableDelete]="disableDelete"
            (addQuestion)="addQuestion()"></cygov-emerging-security-event-action-buttons>
          <cygov-emerging-security-event-table [data]="questions" [selectedData]="selectedQuestion"
            [isEditMode]="isEditMode" (addData)="addQuestion()"
            (updateData)="updateQuestion($event)" (setSelectedRow)="setSelectedRow($event)"
            [isCreateFromTemplate]="true" class="ese-table"
            [initialErrorObject]="initialErrorObject" [keysObject]="keysObject"
            [validationErrors]="validationErrors" [headerItemsESE]="headerItemsESE"
            [isLoading]="isLoading" (onUploadArtifact)="onUploadArtifact($event)"
            (removeArtifact)="removeArtifact($event)" (downLoad)="downLoadScreenView()"
            [failedRows]="failedRows"></cygov-emerging-security-event-table>
        </div>
      </div>
    </div>
    <div class="horizontal-seprator"></div>
    <div class="modal-content-footer">
      <div class="btn-container">
        <cygov-button *ngIf="!steps[0].active " [buttonText]="'<Back'" [buttonColor]="'#030715'"
          [buttonWidth]="'0.5vw'" [textColor]="'#C5C9D1'" [disableClick]="!this.steps[2].completed"
          [fullyDisabled]="!this.steps[2].completed" (click)="moveBackToOldStep()">
        </cygov-button>
        <cygov-button *ngIf="!isFileProcessing"
          [buttonText]="currentStepIndex+1===steps.length?'COMPLETE':'NEXT'" [buttonWidth]="'5vw'"
          [buttonColor]="'#29a9eb'" [hoverColor]="'#0F92E3'" (click)="handleNextStep()"
          [disableClick]="shouldDisableNextStep()" [fullyDisabled]="shouldDisableNextStep()">
        </cygov-button>

      </div>
    </div>
  </div>
</div>

<ng-template #eseCreateFromTemaplteAcknowledgementHeader>
  <!-- Empty for filters -->
</ng-template>
<ng-template #eseCreateFromTemaplteAcknowledgementContent>
  <div
    class='d-flex justify-content-center align-items-center flex-column confirm-filter-popup-content'>
    <div class="tick-icon-container">
      <div class="tick-icon" cygovSvgIcon [svgName]="'complete-popup'"></div>
    </div>
    <span class='lato-22-n-vw text-white text-center'>The Emerging Security Event {{eventName}}
      <br>
      has been successfully created and sent to <span>{{this.selectedVendorName}}</span>

    </span>
  </div>
</ng-template>
<ng-template #eseCreateFromTemaplteAcknowledgementFooter>
  <div class='external-scan-request-acknowledgement-footer d-flex justify-content-center'>
    <cygov-button class='lato-14-n-vw' [buttonText]="'OK'" [buttonWidth]="'6.6vw'" [textSize]="'14'"
      [buttonColor]="'#29A9EB'" [hoverColor]="'#0B76B9'" [buttonHeight]="'2.963vh'"
      (click)="closeModal()"></cygov-button>

  </div>
</ng-template>